// import FloatMenuCart from '../../newComponents/FloatMenuCart'
import { useToken } from 'newHooks/useToken'
import { useValidateSession } from 'newHooks/useValidateSession'
import { useEffect } from 'react'
import FloatMenuSession from './FloatMenuSession'
import styles from './styles.module.sass'


const HeaderGifts = () =>{

    const { atExp, actTime } = useValidateSession() 
    const validaToken = useToken({firstActive: true, name: 'header Navigation', timeRef: 1000})

    useEffect(()=>{
        if(actTime && atExp){
            if(actTime > atExp){
                validaToken.forceToken(true)
            }
        }
    },[atExp, actTime])

    return(
        <header className={styles?.headerGifts}>
            <div className={styles?.container}>
                <div className={styles?.contIcons}>
                    <a href="/" className={styles?.icon_portal} />
                    <span className={styles?.icon_gifts} aria-hidden />
                </div>
                <div className={styles?.cart_gifts}>
                    {/* <FloatMenuCart /> */}
                    <FloatMenuSession />
                </div>
            </div>
        </header>
    )
}


export default HeaderGifts